import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { selectUserRole } from '../authenticateDashboard/authSlice';
import { ROLE_RANK } from './roles';

/**
 * ProtectedRoute — wraps a route and redirects to "/" if the
 * logged-in user's role rank is below the required minRole.
 *
 * Usage:
 *   <ProtectedRoute minRole="admin">
 *     <SomePage />
 *   </ProtectedRoute>
 */
const ProtectedRoute = ({ children, minRole }) => {
  const userRole = useSelector(selectUserRole);

  // While role is still loading (null), render nothing to avoid flash
  if (userRole === null) return null;

  const userRank = ROLE_RANK[userRole] ?? 0;
  const requiredRank = ROLE_RANK[minRole] ?? 0;

  if (userRank < requiredRank) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
